
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'LazyClientShow',
})
export default class LazyClientShow extends Vue {
	isMounted = false;

	// 'when-visible' only works if forceRenderOnServer=true
	@Prop({ default: 'when-idle' }) hydrate: 'when-idle' | 'when-visible';
	@Prop({ default: false }) forceRenderOnServer: boolean;

	mounted() {
		this.isMounted = true;
		if (this.hydrate === 'when-visible' && !this.forceRenderOnServer) {
			throw `[LazyClientShow] can't use when-visible together with forceRenderOnServer=false `;
		}
	}

	get shouldRenderSlot() {
		return this.isMounted || this.forceRenderOnServer;
	}
}
